import * as yup from '@if/core/yup'

export const EditProfileInformationSchema = yup.object({
  firstName: yup.string().validCharacters().max(50).required(),
  lastName: yup.string().validCharacters().max(50).required(),
  jobTitle: yup.string().max(100).required(),
  phone: yup.string().notRequired(),
  language: yup.string().required().oneOf(['fr', 'en']),
})

export type EditProfileInformation = yup.InferType<typeof EditProfileInformationSchema>
